import { render, staticRenderFns } from "./reviewTipsDialog.vue?vue&type=template&id=038f390f&"
import script from "./reviewTipsDialog.vue?vue&type=script&lang=js&"
export * from "./reviewTipsDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports